export const STARTED_SPINNING = 'started-spinning';
export const START_SPINNING_TIME = 2600;
export const CONTINUE_SPINNING_TIME = 750;
export const STOP_SPINNING_TIME = 8000;
export const DEFAULT_SPIN_DURATION = 1.0;
export const DISABLE_INITIAL_ANIMATION = false;
export const WHEEL_WIDTH = 600;
export const WHEEL_HEIGHT = 600;